import React from "react";
import { TradeTransactions } from "./tradeTransactions";

export const TradesTransaction = () => {
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Trades</h1>
      </div>
      <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
        <TradeTransactions chartTitle="Trades" />
      </div>
    </div>
  );
};
